export default class LxpNewsTeaserItemFactory {
  constructor() {
    customElements.define('lxp-news-teaser-item', LxpNewsTeaserItem);
  }
}

class LxpNewsTeaserItem extends HTMLElement {
  news = null;
  fallbackImages = {};
  newstypeLabels = {};

  useShadow = true;

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.useShadow) {
      this.attachShadow({ mode: 'open' });
    }

    this.render();
  }

  setNews(news) {
    this.news = news;
    this.useShadow = false;
    this.setAttribute('data-news-id', news.id);
  }

  get ctaText() {
    return this.getAttribute('cta-text') || 'Mehr';
  }

  set ctaText(text) {
    this.setAttribute('cta-text', text);
  }

  get language() {
    return this.getAttribute('language') || 'en';
  }

  set language(lang) {
    this.setAttribute('language', lang);
  }

  setFallbackImages(images) {
    this.fallbackImages = images;
  }

  setNewstypeLabels(labels) {
    this.newstypeLabels = labels;
  }

  getHtmlParent() {
    if (this.useShadow) {
      return this.shadowRoot;
    }

    return this;
  }

  render() {
    const parent = this.getHtmlParent();

    if (this.useShadow && this.children.length > 0) {
      parent.innerHTML = `<slot></slot>`;
      return;
    }

    if (this.news === null) {
      return;
    }

    parent.innerHTML = `
      <a href="${this.news._link}" class="news-overview-link" data-news-id="${this.news.id}">
        <div class="news-overview-item">
		      <div class="news-overview-item__image">
            <img class="news-overview-item__image-element" src="${this.news.teaserimage?.path ?? this.fallbackImages[this.news.newstype] ?? this.fallbackImages.default}" alt="" />
            <div class="news-overview-item__category news-overview-item__category--${this.news.newstype}">
               ${this.newstypeLabels[this.news.newstype] ?? this.news.newstype}
            </div>
          </div>
          <div class="news-overview-item__content">
            <div class="news-overview-item__title">
              ${this.news.title}
            </div>
            <div class="news-overview-item__teaser-text">
              ${this.news.teasertext ?? ""}
            </div>

            <!-- TODO: BUTTONS -->

            <div class="news-overview-item__date-and-cta">
              <div class="news-overview-item__date">
                ${this.news.date ? new Date(this.news.date).toLocaleDateString(this.language, { year: 'numeric', month: 'long' }) : ''}
              </div>
              <div class="news-overview-item__cta">
                ${this.ctaText}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  }
}
